import { render, staticRenderFns } from "./senha.vue?vue&type=template&id=2b9ee7ba&scoped=true&"
import script from "./senha.vue?vue&type=script&lang=js&"
export * from "./senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ee7ba",
  null
  
)

export default component.exports